<template>
  <div class="change-donation-preferences px30">
    <div class="pt-8">
      <button
        v-if="$route.path !== '/login'"
        v-ripple
        type="button"
        class="btn-empty-wrapper mr-5"
        @click="clickHandler"
      >
        <Close icon="back" />
      </button>
      <CauseChoice v-if="$route.path === '/login'" />
      <h3
        class="page-title color-text text-left text-28 text-text tracking-tight leading-tight mb-2 mt-10"
      >
        <span class="text-primary">{{ $t("My Donation") }}</span>
        <span class="text-secondary">{{ $t("Goals") }}</span>
      </h3>
      <span class="page-subtitle tracking-normal text-text text-left mt-1">
        Your donations will be calculated taking the designated minimum and
        maximum into account
      </span>
    </div>
    <div
      class="form-items form-items-no-icon pt-5 flex flex-col flex-grow form-enabled"
    >
      <FormulateForm #default="{ hasErrors }">
        <div :class="minimumGoal">
          <FormulateInput
            v-model="values.monthly_minimum_goal"
            :options="donationAmount"
            type="select"
            @change="changeDonationList"
            :validation="[['min', min]]"
            :label="$t('Monthly Minimum')"
          />
        </div>
        <div
          v-if="maximumDonationOptions.length"
          class="pt-4"
          :class="maximumDonations"
        >
          <FormulateInput
            v-model="values.maximum_donation"
            :options="maximumDonationOptions"
            type="select"
            :label="$t('Monthly Maximum')"
          />
        </div>
        <div class="pt-4" :class="roundup">
          <div class="flex justify-between">
            <p class="w-52 text-14 text-black mb-5">
              We will roundup your change to the nearest whole dollar.
            </p>
            <div class="flex justify-center items-center w-20">
              <p class="text-20">${{ values.roundup_amount }}.00</p>
            </div>
          </div>
        </div>
        <div
          v-if="$user('pr_bank') && $user('pr_card') && $user('pr_donation')"
          class="switcher-container flex justify-between items-center pt-4 mt-5 mb-10"
        >
          <span class="text-text text-20 font-medium tracking-normal pr-2">
            {{ $t("Pause All Donations") }}
          </span>
          <label for="donationPause" class="input-switcher" :class="switcher">
            <input
              id="donationPause"
              type="checkbox"
              v-model="values.pause"
              @change="isDonationModal = values.pause"
            />
            <span v-if="values.pause" class="donation-yes">Yes</span>
            <span v-else class="donation-no">No</span>
          </label>
        </div>
        <div class="description text-center px30 py-6">
          <img
            v-if="!$getState('corporation')['is']"
            :src="`${$store.state.appUrl}/img/pwa/icons-heart.svg`"
            class="m-auto mb-3"
          />
          <p class="text-12">
            A minimum of $15 per month is needed to keep your account active,
            but you can increase your donation to your desired amount.
          </p>
        </div>
        <DonationsModal
          v-if="values.pause && isDonationModal"
          @pause="values.pause = $event"
          @close="isDonationModal = false"
        />
        <div class="form-item-row form-item-row_last save-donation-preferences">
          <FormulateButton
            :form-handler="formHandler"
            :has-errors="hasErrors"
            :title="'Save'"
          />
        </div>
      </FormulateForm>
    </div>
  </div>
</template>

<script>

import Close from "../UI/Close";
import CauseChoice from "../UI/CauseChoice";
import DonationsModal from "../Modal/DonationsModal.vue";
import FormulateButton from "../UI/FormulateButton";

export default {
  name: "ChangeDonationPreferences",

  components: { 
    CauseChoice, 
    Close, 
    DonationsModal, 
    FormulateButton, 
  },

  props: {
    clickHandler: {
      type: Function
    }
  },

  data: function() {
    return {
      values: {
        monthly_minimum_goal: parseInt(this.$user("monthly_minimum_goal"), 10) || "15",
        maximum_donation: parseInt(this.$user("maximum_donation"), 10) || "No Limit",
        roundup_amount: parseInt(this.$user("roundup_amount"), 10) || "1",
        pause: this.$route.path === "/login" ? 0 : this.$user("is_pause_donation"),
        is_pause_donation: this.$user("is_pause_donation"),
        multiply: this.$user("multiply"),
        pr_donation: true
      },
      min: 15,
      donationAmount: [15, 25, 35, 45, 55, 65, 75, 85, 95, 100],
      maximumDonationOptions: [],
      isDonationModal: false
    };
  },
  mounted() {
    this.maximumDonationOptions = ["No Limit", ...this.donationAmount];
  },
  computed: {
    minimumGoal() {
      return {
        "show-currency": this.values.monthly_minimum_goal
      };
    },
    maximumDonations() {
      return {
        "show-currency": this.values.maximum_donation && this.values.maximum_donation !== "No Limit",
        "remove-sign":  this.values.maximum_donation && this.values.maximum_donation == "No Limit"
      };
    },
    roundup() {
      return {
        "show-currency": this.values.roundup_amount
      };
    },
    switcher() {
      return {
        "input-switcher_checked": this.values.pause
      };
    }
  },
  methods: {
    formHandler: function() {
      window.scrollTo(0, 0);
      this.values.is_pause_donation = this.values.pause;
      const payload = {
        ...this.values
      };
      if (this.values.maximum_donation == "No Limit") {
        payload.maximum_donation = 0;
      }
      this.$http.post("user/savedonation", payload).then(data => {
        if (data && data.status !== undefined && data.status) {
          this.$setState("userUpdate", this.values);

          if (this.$route.path === "/login") {
            this.clickHandler();
          }
        }
      });
    },
    changeDonationList() {
      this.values.maximum_donation = "No Limit";
      this.maximumDonationOptions = [];
      const temp = this.donationAmount.filter(
        d => d >= this.values.monthly_minimum_goal
      );
      this.maximumDonationOptions = ["No Limit", ...temp];
    }
  }
};
</script>
